import { useState } from 'react'
import { Layout } from '../../widgets'
import * as routes from '../../routes'
import { useAdminTitle } from '../../shared'
import { AdminPostCell, FilterPicker, } from '../components'
import { NavigationTab, PaginatedList } from '../../components'

const AdminPosts = (props) => {
  const [tab, setTab] = useState('Trending')
  const [region, setRegion] = useState(null)

  useAdminTitle('Tracks')

  const tabs = {
    'Trending': <PaginatedList
      featuredUrl={routes.adminPostFeaturedUrl}
      loadUrl={routes.adminPostTrendingUrl}
      loadParams={{}}
      cell={AdminPostCell}
      cellItemPropName={'post'}
      datePicker={true}
      featureActionUpdateBehavior={'filter'}
    />,
    'Featured': <PaginatedList
      key={'recently_featured'}
      loadUrl={routes.adminPostFeaturedUrl}
      loadParams={{}}
      featuredUrl={routes.adminPostFeaturedUrl}
      cell={AdminPostCell}
      cellItemPropName={'post'}
      featureActionUpdateBehavior={'filter'}
    />,
    'Trending Feed': <>
      <FilterPicker.Region onChange={(value) => setRegion(value[0])} />
      <PaginatedList
        key={region ? `hot_local_${region}` : 'all_scored'}
        loadUrl={routes.adminPostFeedUrl}
        loadParams={region ? {'type': 'hot_local', 'region': region} : {'type': 'all_scored'}}
        featuredUrl={routes.adminPostFeaturedUrl}
        cell={AdminPostCell}
        cellItemPropName={'post'}
      />
    </>,
    'Featured Feed': <PaginatedList
      key={'featured_new'}
      loadUrl={routes.adminPostFeedUrl}
      loadParams={{'type': 'featured_new'}}
      featuredUrl={routes.adminPostFeaturedUrl}
      cell={AdminPostCell}
      cellItemPropName={'post'}
    />,
    'New Feed': <>
      <FilterPicker.Region onChange={(value) => setRegion(value[0])} />
      <PaginatedList
        key={region ? `new_local_${region}` : 'all_new'}
        loadUrl={routes.adminPostFeedUrl}
        loadParams={region ? {'type': 'new_local', 'region': region} : {'type': 'all_new'}}
        featuredUrl={routes.adminPostFeaturedUrl}
        cell={AdminPostCell}
        cellItemPropName={'post'}
      />
    </>,
  }

  return (
    <div className='body-container'>
      <Layout>
        <Layout.Header>Tracks</Layout.Header>
        <div className='moderator-content'>

          <div className='navigation-tabs'>
            {Object.keys(tabs).map((t, i) =>
              <NavigationTab
                key={i}
                text={t}
                isActive={tab === t}
                onClick={() => {
                  if (tab !== t) {
                    setTab(t)
                  }
                }}
              />
            )}
          </div>

          {tabs[tab]}

        </div>
      </Layout>
    </div>
  )
}

export default AdminPosts
